import type { CSSInterpolation } from '@emotion/serialize';
import { useState } from 'react';

import IconPictureLine from '~icons/clarity/picture-line';

import { theme } from '@adflow/frontend/ui-theme';

/**
 * Globally keep track of which image URLs have failed.
 */
const failedUrls = new Set<string>();

function FallbackImage(props: {
	width: number | 'auto';
	height: number | 'auto';
}) {
	const { width, height } = props;
	return (
		<IconPictureLine
			width={width}
			height={height}
			css={{ color: theme.colors.action.disabledBackground }}
		/>
	);
}

export interface RenderSimpleImageProps {
	src: string | null;
	imageStyle?: CSSInterpolation;
}

/**
 * A component that renders a image or a broken image placeholder if an error is encountered
 */
export function RenderSimpleImage({ src, imageStyle }: RenderSimpleImageProps) {
	const [imageError, setImageError] = useState(!src || failedUrls.has(src));

	if (imageError) {
		return <FallbackImage width="auto" height="auto" />;
	}

	return (
		// eslint-disable-next-line jsx-a11y/alt-text
		<img
			src={src ?? undefined}
			css={imageStyle}
			onError={() => {
				/**
				 * Mark the src as failed so that it goes straight to
				 * the fallback on remounting.
				 */
				if (src) {
					failedUrls.add(src);
				}

				setImageError(true);
			}}
		/>
	);
}
